// updateStore always sends name and currency, so a section that saves only its
// own fields still has to pass them: the saved values, never another section's
// unsaved edits. A store without a currency gets the euro, as Settings always did.
export function baseStorePayload(store) {
  return {
    storeId: store.id,
    name: store.name || "",
    currency: store.currency || "€",
  };
}

export const ACTIVE_SUBSCRIPTION_STATUSES = ["active", "past_due", "trialing"];

export function hasRunningSubscription(store) {
  return ACTIVE_SUBSCRIPTION_STATUSES.includes(store?.subscription_status);
}

export const HEX_COLOR = /^#[0-9a-f]{6}$/i;
